import ListCreditScoreByCompanyTypeBox from './ListCreditScoreByCompanyTypeBox'

export default ListCreditScoreByCompanyTypeBox
